import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { fadeInOut, slideLeftSidebar } from 'app/utils/animations.util';

@Component({
	selector: 'modal-sidebar',
	templateUrl: './modal-sidebar.component.html',
	styleUrls: ['./modal-sidebar.component.scss'],
	animations: [slideLeftSidebar, fadeInOut],
})
export class ModalSidebar implements OnChanges, OnDestroy {
	showBackground = false;
	showSidebar = false;

	@Input() visible = false;
	@Input() title = '';
	@Input() closeOnClickOutside = true;
	@ViewChild('sidebar') sidebarRef: ElementRef;
	@Output('closeModal') emClose = new EventEmitter<void>();

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.visible.firstChange) {
			changes.visible.currentValue ? this.openComp() : this.closeComp();
		}
	}

	ngOnDestroy(): void {
		document.body.style.overflow = 'auto';
	}

	openComp(): void {
		this.showBackground = true;

		const timer = setInterval(() => {
			this.showSidebar = true;
			document.body.style.overflow = 'hidden';
			clearInterval(timer);
		}, 300);
	}

	closeComp(): void {
		this.showSidebar = false;

		const timer = setInterval(() => {
			this.showBackground = false;
			document.body.style.overflow = 'auto';
			clearInterval(timer);
		}, 300);
	}

	closeSidebar() {
		this.closeComp();
		this.emClose.emit();
	}
}
